import React, { useState } from 'react';
import { Collapse, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const RecursiveCategoryItem = ({ category, selectedCategoryIds, onSelect, level = 0 }) => {
    const [expanded, setExpanded] = useState(false);
    const hasChildren = category.subCategory && category.subCategory.length > 0;

    const handleToggle = (e) => {
        e.stopPropagation();
        setExpanded(!expanded);
    };

    const handleClick = (e) => {
        e.preventDefault();
        onSelect(category.id);
    };

    const isSelected = selectedCategoryIds.includes(category.id);

    return (
        <div className="recursive-category-item" style={{ marginLeft: `${level * 15}px` }}>
            <div
                className={`category-item-content ${isSelected ? 'active' : ''}`}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px 8px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                    transition: 'background-color 0.2s'
                }}
                onClick={handleClick}
            >
                {hasChildren ? (
                    <IconButton
                        size="small"
                        onClick={handleToggle}
                        style={{ padding: '0px', marginRight: '4px' }}
                    >
                        {expanded ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />}
                    </IconButton>
                ) : (
                    <div style={{ width: '24px' }}></div>
                )}

                <span
                    style={{
                        fontSize: '14px',
                        fontWeight: isSelected || level === 0 ? '600' : 'normal',
                        color: isSelected ? '#0083ca' : '#333',
                        flex: 1
                    }}
                >
                    {category.name}
                </span>
            </div>

            {hasChildren && (
                <Collapse in={expanded || isSelected} timeout="auto" unmountOnExit>
                    <div className="subcategory-list" style={{ marginTop: '2px' }}>
                        {category.subCategory
                            .sort((a, b) => (a.position || 0) - (b.position || 0))
                            .map((child) => (
                                <RecursiveCategoryItem
                                    key={child.id}
                                    category={child}
                                    selectedCategoryIds={selectedCategoryIds}
                                    onSelect={onSelect}
                                    level={level + 1}
                                />
                            ))}
                    </div>
                </Collapse>
            )}
        </div>
    );
};

export default RecursiveCategoryItem;
